import React from 'react';
import PropTypes from 'prop-types';
import { ReactComponent as UnicornSvg } from '../../assets/unicorn-logo-traced.svg';
import { getUniversityTheme } from '../../pages/Social/universityTheme';

// The logo's sash is its own path in the traced SVG (the second one, "silver"),
// so it can wear a school's colour without a second asset. Grey until the
// person's university is verified: the colour is a claim, and only a verified
// school gets to make it.
export const SASH_GREY = '#B8B8B8';

// One rule for every user shape the app passes around: the signed-in user
// carries `universityVerification`, directory/profile payloads carry the
// server's `universityVerified` flag beside `freelancerProfile.university`.
export function verifiedSchoolOf(user) {
  if (user?.universityVerification?.status === 'verified') {
    return user.universityVerification.universityClaimed || user.freelancerProfile?.university || user.university || '';
  }
  if (user?.universityVerified) return user.freelancerProfile?.university || user.university || '';
  return '';
}

export function sashColorFor(school) {
  return school ? getUniversityTheme(school).primary : SASH_GREY;
}

export default function LogoMark({ sash, className, style }) {
  return (
    <UnicornSvg
      aria-hidden="true"
      focusable="false"
      // .uf-mark (index.css) points the sash path's fill at --uf-sash.
      className={className ? `uf-mark ${className}` : 'uf-mark'}
      style={{ height: '64%', width: 'auto', '--uf-sash': sash || SASH_GREY, ...style }}
    />
  );
}

LogoMark.propTypes = {
  sash: PropTypes.string,
  className: PropTypes.string,
  style: PropTypes.object,
};

LogoMark.defaultProps = {
  sash: SASH_GREY,
  className: null,
  style: null,
};
